import AlternativesListsQueries from '@Alternatives/AlternativesLists/Domain/queries-vue-component';
import { ICommandBase } from '@Alternatives/cqrs';
import { CreateNotificationEventPayload, NotificationEditorViewModel, UpdateNotificationEventPayload } from '@Alternatives/Notifications/Components/NotificationEditor';
import NotificationEditor from '@Alternatives/Notifications/Components/NotificationEditor.vue';
import { CreateNotificationCommandV1, DeleteNotificationCommandV1, UpdateNotificationCommandV1 } from '@Alternatives/Notifications/Domain/commands-core';
import NotificationsCommands from '@Alternatives/Notifications/Domain/commands-vue-component';
import NotificationsQueries from '@Alternatives/Notifications/Domain/queries-vue-component';
import { NotificationReadModel, NotificationsPageReadModel } from '@Alternatives/Notifications/Domain/readmodels';
import { dateCompare1, strCompareLowerCase } from '@common/Common';
import PortfolioNavigation from "@common/Components/PortfolioNavigation.vue";
import { ICommandStatus } from "@cqrs/cqrs";
import moment from "moment";
import Component, { mixins } from 'vue-class-component';


@Component({
    components: { PortfolioNavigation, NotificationEditor }
})
export default class NotificationsPage extends mixins(NotificationsQueries, AlternativesListsQueries, NotificationsCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get projectId(): number { return Number.parseInt(this.$route.params.projectId); }

    rm: NotificationsPageReadModel | null = null;

    SearchPhrase: string | null = null;
    OrderBy: string = "modified";
    OrderByDescending: boolean = true;

    notificationEditor = new NotificationEditorViewModel();

    get NotificationsView()
    {
        let view = new Array(...this.rm.Notifications);

        if (this.SearchPhrase)
        {
            const phrase = this.SearchPhrase.toLowerCase();
            view = view.filter(o => o.Name.toLowerCase().indexOf(phrase) >= 0);
        }

        if (this.OrderBy === "name")
        {
            view = view.sort((a, b) => strCompareLowerCase(a.Name, b.Name));
        }
        else if (this.OrderBy === "modified")
        {
            view = view.sort((a, b) => dateCompare1(a.Modified, b.Modified));
        }
        else if (this.OrderBy === "created")
        {
            view = view.sort((a, b) => dateCompare1(a.Created, b.Created));
        }

        if (this.OrderByDescending === true)
        {
            view = view.reverse();
        }

        return view;
    }


    getFormattedDateStr(date: string): string 
    {
        return moment(date).format('MMM D, YYYY');
    }

    getFormattedTimeStr(date: string): string 
    {
        return moment(date).format('LT');
    }


    orderByName()
    {
        if (this.OrderBy === 'name')
        {
            this.OrderByDescending = !this.OrderByDescending;
        }
        else
        {
            this.OrderByDescending = false;
            this.OrderBy = 'name';
        }
    }

    orderByModified()
    {
        if (this.OrderBy === 'modified')
        {
            this.OrderByDescending = !this.OrderByDescending;
        }
        else
        {
            this.OrderByDescending = true;
            this.OrderBy = 'modified';
        }
    }

    orderByCreated()
    {
        if (this.OrderBy === 'created')
        {
            this.OrderByDescending = !this.OrderByDescending;
        }
        else
        {
            this.OrderByDescending = true;
            this.OrderBy = 'created';
        }
    }


    showNotificationCreator()
    {
        this.notificationEditor.showCreator(this.rm.UserEmail, this.rm.AlternativeLabel, this.rm.Statuses[0].Id);
    }

    showNotificationEditor(n: NotificationReadModel)
    {
        this.notificationEditor.showEditor(n);
    }

    handleCreateNotificationCommand(e: CreateNotificationEventPayload)
    {
        this.invokeCreateNotificationCommandV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, 0,
            e.name, e.description, e.enabled, e.statusId, e.prevStatusId, e.emailSubject, e.emailMessage, e.emailRecipientAttributeId, e.emailAdHocRecipients, e.emailReplyToEmail);
    }

    handleUpdateNotificationCommand(e: UpdateNotificationEventPayload)
    {
        this.invokeUpdateNotificationCommandV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, e.id,
            e.name, e.description, e.enabled, e.statusId, e.prevStatusId, e.emailSubject, e.emailMessage, e.emailRecipientAttributeId, e.emailAdHocRecipients, e.emailReplyToEmail);
    }

    handleDeleteNotificationCommand(n: NotificationReadModel)
    {
        if (confirm("Are you sure?") == true)
        {
            this.invokeDeleteNotificationCommandV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, n.Id);
        }
    }

    mounted()
    {
        document.title = "Notifications | TransparentChoice";
        this.runNotificationsPageQueryV1(this.workspaceId, this.projectId);
    }


    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "NotificationsPageReadModel")
        {
            this.rm = model as NotificationsPageReadModel;

            const emailSnippets = [... this.rm.BaseEmailSnippets, ... this.rm.FormEmailSnippets, ... this.rm.AttributeEmailSnippets];

            this.notificationEditor.setData(this.rm.Statuses, this.rm.Attributes, emailSnippets);

        }
        else if (modelName == "NotificationReadModel")
        {
            const rm = model as NotificationReadModel;
            this.rm.Notifications = this.rm.Notifications.filter(a => a.Id !== rm.Id);
            this.rm.Notifications.push(rm);

            this.notificationEditor.close();
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string, result: any)
    {
        if (CreateNotificationCommandV1.matchType(cmd))
        {
            this.runNotificationByIdQueryV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, Number(result));
        }
        else if (UpdateNotificationCommandV1.matchType(cmd))
        {
            this.runNotificationByIdQueryV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, Number(correlationId));
        }
        else if (DeleteNotificationCommandV1.matchType(cmd))
        {
            this.rm.Notifications = this.rm.Notifications.filter(n => n.Id !== Number(correlationId));
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (CreateNotificationCommandV1.matchType(status.Command))
        {
            this.notificationEditor.displayValidationErrors(status.ValidationErrors);
        }
        else if (UpdateNotificationCommandV1.matchType(status.Command))
        {
            this.notificationEditor.displayValidationErrors(status.ValidationErrors);
        }
    }
}